import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class Back extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon fill="#F0F0F0" {...this.props}>
                <path
                    d={`M6.9,11.5l2.6-2.8c0.4-0.4,0.4-1,0-1.5c0,0,0,0,0,0c-0.4-0.4-1-0.3-1.3,0l-3.6,3.9
                        c-0.7,0.8-0.7,1.9,0,2.7l3.6,3.8c0,0,0,0,0.1,0.1c0.4,0.3,1,0.3,1.3-0.1c0.4-0.4,0.4-1.1,0-1.5l-2.5-2.6H20c0.5,0,1-0.4,1-1
                        c0-0.5-0.4-1-1-1H6.9z`}
                />
            </SvgIcon>
        );
    }
}
